import FeedList from "./FeedList"
import useFetchApps from "utils/useFetchApps"
import { fetchApps } from "queries"
import usePullToRefresh from "utils/usePullToRefresh"
import useFiltersStore from "stores/filters"

const Apps = () => {
  const price = useFiltersStore((state) => state.price)

  const {
    data: apps,
    isFetchingNextPage,
    refetch,
    fetchNextPage,
  } = useFetchApps({
    queryFn: ({ pageParam }) => fetchApps({ price, pageParam }),
    queryKey: price ? ["getApps", price] : ["getApps"],
  })

  usePullToRefresh({ refetch, element: "#apps-card", page: "apps" })

  return (
    <div id="apps-card">
      <FeedList
        apps={apps}
        isPending={isFetchingNextPage}
        endReached={fetchNextPage}
      />
    </div>
  )
}
export default Apps
